import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';
import { getShapeByPoi } from '../utils/functions';

const SearchCard = observer(({ interactiveRef, handleExitWayfinding }) => {
    const { mapStore, mainStore } = useStores();

    const searchButtonStyle =
        'flex items-center gap-4 w-full bg-white border border-[#1C1C1C] px-3 cursor-default';

    const searchInputStyle = `flex-1 py-[6px] text-left text-xs sm:text-sm leading-[22px] sm:leading-[28px] truncate cursor-pointer`;

    const ClearIcon = ({ type = 'destination' }) => {
        return (
            <svg
                className="z-[80] cursor-pointer"
                onClick={() => {
                    if (type === 'start') {
                        mainStore.setStartPoi(null);
                        mainStore.setWayfindingShapeFrom(null);
                        mapStore.setStartShape(null);
                    } else {
                        mainStore.setDestinationPoi(null);
                        mainStore.setWayfindingShapeTo(null);
                        mapStore.setDestinationShape(null);
                    }
                }}
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_962_603)">
                    <path
                        d="M1 3.5H13"
                        stroke="#FF0000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M2.5 3.5H11.5V12.5C11.5 12.7652 11.3946 13.0196 11.2071 13.2071C11.0196 13.3946 10.7652 13.5 10.5 13.5H3.5C3.23478 13.5 2.98043 13.3946 2.79289 13.2071C2.60536 13.0196 2.5 12.7652 2.5 12.5V3.5Z"
                        stroke="#FF0000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M4.5 3.5V3C4.5 2.33696 4.76339 1.70107 5.23223 1.23223C5.70107 0.763392 6.33696 0.5 7 0.5C7.66304 0.5 8.29893 0.763392 8.76777 1.23223C9.23661 1.70107 9.5 2.33696 9.5 3V3.5"
                        stroke="#FF0000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M5.5 6.50146V10.503"
                        stroke="#FF0000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M8.5 6.50146V10.503"
                        stroke="#FF0000"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_962_603">
                        <rect width="14" height="14" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    };

    const BulletPoint = ({ type = 'start' }) => {
        return (
            <img
                alt=""
                src={require(`../img/${
                    type === 'start' ? 'Pin_Blue.png' : 'Pin_Red.png'
                }`)}
                className="w-4 h-auto"
            />
        );
        // if (type === 'start') {
        //     return (

        //         // <svg
        //         //     width="12"
        //         //     height="12"
        //         //     viewBox="0 0 12 12"
        //         //     fill="none"
        //         //     xmlns="http://www.w3.org/2000/svg"
        //         // >
        //         //     <g clip-path="url(#clip0_4119_11400)">
        //         //         <path
        //         //             fill-rule="evenodd"
        //         //             clip-rule="evenodd"
        //         //             d="M11.9661 0.595573C12.0341 0.434847 11.9979 0.248941 11.8745 0.125539C11.7511 0.00213522 11.5652 -0.0341156 11.4045 0.0338837L0.261584 4.74817C0.107565 4.81333 0.0055176 4.96213 0.000216508 5.12928C-0.00508458 5.29644 0.0873286 5.45141 0.236909 5.52619L4.39485 7.60517L6.47382 11.7631C6.54861 11.9127 6.70358 12.0051 6.87073 11.9998C7.03788 11.9945 7.18668 11.8924 7.25184 11.7384L11.9661 0.595573Z"
        //         //             fill="#EE3333"
        //         //         />
        //         //     </g>
        //         //     <defs>
        //         //         <clipPath id="clip0_4119_11400">
        //         //             <rect width="12" height="12" fill="white" />
        //         //         </clipPath>
        //         //     </defs>
        //         // </svg>
        //     );
        // } else {
        //     return (
        //         <svg
        //             width="12"
        //             height="12"
        //             viewBox="0 0 12 12"
        //             fill="none"
        //             xmlns="http://www.w3.org/2000/svg"
        //         >
        //             <path
        //                 fill-rule="evenodd"
        //                 clip-rule="evenodd"
        //                 d="M2.28544 0.0390625C2.46375 0.0390625 2.6251 0.11166 2.74156 0.228911L10.1214 3.91886C10.2666 3.99146 10.3584 4.13985 10.3584 4.30219C10.3584 4.46452 10.2666 4.61292 10.1214 4.68551L2.92829 8.2821V11.3199C2.92829 11.675 2.64048 11.9628 2.28544 11.9628C1.9304 11.9628 1.64258 11.675 1.64258 11.3199V0.68192C1.64258 0.326879 1.9304 0.0390625 2.28544 0.0390625Z"
        //                 fill="#0076C0"
        //             />
        //         </svg>
        //     );
        // }
    };

    const handleSwitchLocation = () => {
        if (!mainStore.startPoi && !mainStore.destinationPoi) return;
        const start = mainStore.destinationPoi;
        const startShape = getShapeByPoi(start, mapStore.freeShapes);
        const destination = mainStore.startPoi;
        const destinationShape = getShapeByPoi(
            destination,
            mapStore.freeShapes
        );

        if (mapStore.isAnimating) handleExitWayfinding();

        if (mapStore.directions?.length > 0 && interactiveRef?.current) {
            interactiveRef.current.resetMap();
            [...mapStore.freeShapes, ...mapStore.model3ds].forEach((e) => {
                if (e.topImage)
                    interactiveRef.current.changeTopImage(e._id, null);
            });
        }

        mainStore.setStartPoi(start);
        mainStore.setWayfindingShapeFrom(startShape);
        mapStore.setStartShape(startShape);

        mainStore.setDestinationPoi(destination);
        mainStore.setWayfindingShapeTo(destinationShape);
        mapStore.setDestinationShape(destinationShape);
    };

    return (
        <div
            id="both-field"
            className="relative bg-[#F7F6F6] border border-[#E4E4E4] px-4 py-3 space-y-4"
            style={{
                backdropFilter: 'blur(20px)',
            }}
        >
            <div className="relative flex items-center gap-3">
                <div className="flex flex-col items-center justify-center gap-1 h-[86px] sm:h-[100px] px-1 py-3">
                    <BulletPoint />
                    <div className="flex-1 border-l-2 border-dashed border-[#FF6200]" />
                    <BulletPoint type="destination" />
                </div>
                <div className="flex-1 space-y-3 sm:space-y-4">
                    <div>
                        <button
                            id="start-field"
                            className={`${
                                mainStore.startPoi
                                    ? 'text-[#5C5C5C]'
                                    : 'text-[#9C9C9C]'
                            } ${searchButtonStyle}`}
                        >
                            <p
                                className={searchInputStyle}
                                onClick={() => {
                                    mainStore.setStartPoi(null);
                                    mainStore.setIsPoiOverlay(false);
                                    mainStore.setSelectedPoiDetail(null);
                                    mainStore.setTypeSearchHistory('start');
                                }}
                            >
                                {mainStore.startPoi?.name || `Your Location`}
                            </p>
                            {mainStore.startPoi &&
                                mapStore.directions.length === 0 && (
                                    <ClearIcon type={'start'} />
                                )}
                        </button>
                    </div>
                    <div>
                        <button
                            className={`${
                                mainStore.destinationPoi
                                    ? 'text-[#5C5C5C]'
                                    : 'text-[#9C9C9C]'
                            } ${searchButtonStyle}`}
                        >
                            <p
                                className={searchInputStyle}
                                onClick={() => {
                                    mainStore.setDestinationPoi(null);
                                    mainStore.setIsPoiOverlay(false);
                                    mainStore.setSelectedPoiDetail(null);
                                    mainStore.setTypeSearchHistory(
                                        'destination'
                                    );
                                }}
                            >
                                {mainStore.destinationPoi?.name ||
                                    `Your Destination`}
                            </p>

                            {mainStore.destinationPoi &&
                                mapStore.directions.length === 0 && (
                                    <ClearIcon />
                                )}
                        </button>
                    </div>
                </div>

                <svg
                    className="cursor-pointer"
                    onClick={() => handleSwitchLocation()}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_4119_11388)">
                        <path
                            d="M0.571289 5.71652L3.42843 2.85938L6.28558 5.71652"
                            stroke="black"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M6.85728 15.4308H4.57157C4.26846 15.4308 3.97777 15.3103 3.76344 15.0961C3.54912 14.8818 3.42871 14.591 3.42871 14.2879V2.85938"
                            stroke="black"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M15.4282 10.2812L12.571 13.1384L9.71387 10.2812"
                            stroke="black"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M9.14258 0.570312H11.4283C11.7314 0.570312 12.0221 0.69072 12.2364 0.905047C12.4507 1.11938 12.5711 1.41006 12.5711 1.71317V13.1417"
                            stroke="black"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_4119_11388">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>
    );
});

export default SearchCard;
